import type {
  ContractDataFieldSectionDto,
  ContractReportQueryDto,
  CustomContractDataFieldDto,
  CustomFieldValuesDto,
} from "../../../autogen/bff-api";

type Sections = { [key: string]: ContractDataFieldSectionDto } | null | undefined;

export const fieldChoices = (field: CustomContractDataFieldDto): string[] | null =>
  field.type === "CustomEnum" || field.type === "CustomMultiEnum" ? (field.options ?? []) : null;

export const withChosenValues = (
  current: CustomFieldValuesDto[] | null | undefined,
  fieldId: string,
  values: string[],
): CustomFieldValuesDto[] | undefined => {
  const others = (current ?? []).filter((filter) => filter.fieldId !== fieldId);
  const next = values.length > 0 ? [...others, { fieldId, values }] : others;
  return next.length > 0 ? next : undefined;
};

export const withCurrentChoices = (
  q: Partial<ContractReportQueryDto>,
  sections: Sections,
): Partial<ContractReportQueryDto> => {
  if (!q.customFieldValues?.length) return q;
  const choices = new Map(
    Object.values(sections ?? {})
      .flatMap((section) => section.fields)
      .map((field) => [field.id, fieldChoices(field)] as const),
  );
  const kept = q.customFieldValues
    .map(({ fieldId, values }) => ({ fieldId, values: values.filter((value) => choices.get(fieldId)?.includes(value)) }))
    .filter((filter) => filter.values.length > 0);
  return { ...q, customFieldValues: kept.length > 0 ? kept : undefined };
};
